import PipelineCreate from "../Pipelines/PipelineCreate";

export default PipelineCreateV2;

function PipelineCreateV2(props) {
  const { onPipelineCreate, onPipelineCreated } = props;

  const handleCreate = (payload, lifecycleCbs) => {
    const { success, ...rest } = lifecycleCbs;

    const updatedLifecycleCbs = {
      ...rest,
      success(data) {
        lifecycleCbs.success();
        onPipelineCreated(data.pipeline._id);
      },
    };

    onPipelineCreate(payload, updatedLifecycleCbs);
  };

  return <PipelineCreate onPipelineCreate={handleCreate} />;
}
